// extracted by mini-css-extract-plugin
module.exports = {"items":"SitemapLinks_items__bkT_z","items--root":"SitemapLinks_items--root__cZUmH","link":"SitemapLinks_link__NcSWu","link--root":"SitemapLinks_link--root__bi5kR"};